// extracted by mini-css-extract-plugin
export default {"cardTitle":"PanelTitle_cardTitle__pREmb"};